import React, { InputHTMLAttributes, TextareaHTMLAttributes } from "react";

type InputElementProps = {
  resolvedClass: string;
  type?: string;
  multiline?: boolean;
} & TextareaHTMLAttributes<HTMLElement> &
  InputHTMLAttributes<HTMLElement>;

const InputElement: React.FC<InputElementProps> = ({
  type,
  resolvedClass,
  multiline,
  ...rest
}) => {
  if (multiline) {
    return <textarea {...rest} className={resolvedClass}></textarea>;
  }
  return <input type={type || "text"} {...rest} className={resolvedClass} />;
};

interface InputProps
  extends InputHTMLAttributes<HTMLElement>,
    TextareaHTMLAttributes<HTMLElement> {
  type?: string;
  wrapperClass?: string;
  className?: string;
  multiline?: boolean;
  error?: string;
  disabled?: boolean;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

const Input: React.FC<InputProps> = ({
  type,
  className,
  wrapperClass,
  error,
  multiline,
  ...rest
}) => {
  const resolvedClass = `hw-shadow-sm focus:hw-ring-indigo-500 focus:hw-border-indigo-500 hw-block hw-w-full sm:hw-text-sm hw-border-gray-300 hw-rounded-md ${className} ${
    rest.disabled ? "hw-bg-gray-100 hw-text-gray-500" : "hw-text-gray-800 hw-bg-white"
  }${
    error
      ? " hw-border-red-300 hw-text-red-900 hw-placeholder-red-300 focus:hw-border-red-300"
      : ""
  }`;

  const element = (
    <InputElement
      type={type}
      resolvedClass={resolvedClass}
      multiline={multiline}
      {...rest}
    />
  );
  return (
    <>
      <div className={`hw-flex hw-relative hw-rounded-md hw-shadow-sm ${wrapperClass}`}>
        {element}
      </div>
      {error && <p className="hw-mt-1 hw-text-xs hw-text-red-600">{error}</p>}
    </>
  );
};

export default Input;
